<template>
    <ul class="navbar-nav me-auto">
      <li v-for="menu in visibleMenus" :key="menu.label" class="nav-item me-3">
  
        <!-- Se la voce ha figli -->
        <template v-if="menu.children && menu.children.length">
          <div class="nav-link d-flex justify-content-between align-items-center"
               @click="toggleMenu(menu.label)">
            <div><i :class="menu.icon"></i> {{ menu.label }}</div>
            <i class="bi"
               :class="openMenus.includes(menu.label) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </div>
  
          <ul v-if="openMenus.includes(menu.label)"
              class="nav flex-column ms-3 mt-1 submenu">
            <li v-for="child in menu.children" :key="child.label" class="nav-item">
              <a class="nav-link"
                 :class="{ active: currentView === child.view }"
                 @click="$emit('change-view', child.view)">
                <i :class="child.icon"></i> {{ child.label }}
              </a>
            </li>
          </ul>
        </template>
  
        <!-- Se è una voce singola -->
        <template v-else>
          <a class="nav-link me-3"
             :class="{ active: currentView === menu.view, 'fw-bold': currentView === menu.view }"
             @click="$emit('change-view', menu.view)">
            <i :class="menu.icon"></i> {{ menu.label }}
          </a>
        </template>
      </li>
    </ul>
  </template>
  
  <script>
import { menuMap } from '../../components/menuMap.js';
  
  export default {
    name: 'NavbarTemplate',
    props: {
      currentView: {
        type: String,
        required: true
      },
      userPermissions: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        menuMap,
        openMenus: []
      };
    },
    computed: {
      visibleMenus() {
        return this.menuMap
          .map(menu => {
            if (!menu) return null;
            if (menu.children && Array.isArray(menu.children)) {
              const visibleChildren = menu.children.filter(child =>
                child.requiredPermissions?.some(p => this.userPermissions.includes(p))
              );
              return visibleChildren.length
                ? { ...menu, children: visibleChildren }
                : null;
            } else if (menu.requiredPermissions?.some(p => this.userPermissions.includes(p))) {
              return menu;
            }
            return null;
          })
          .filter(Boolean);
      }
    },
    methods: {
      toggleMenu(label) {
        if (this.openMenus.includes(label)) {
          this.openMenus = this.openMenus.filter(l => l !== label);
        } else {
          this.openMenus.push(label);
        }
      }
    },
    emits: ['change-view']
  };
  </script>
  
  <style scoped>
  .nav-link {
    cursor: pointer;
    transition: transform 0.2s;
  }
  
  .nav-link:hover {
    transform: translateX(2px);
  }
  </style>
  